var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "messageList" } }, [
    _c("section", [
      _vm.selectedEvent.messages && _vm.selectedEvent.messages.length > 0
        ? _c("div", { staticClass: "messageList" }, [
            _vm.selectedEvent.messages && _vm.selectedEvent.messages.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.selectedEvent.messages, function(message, i) {
                    return _c("div", { key: i, staticClass: "message" }, [
                      _c("div", { staticClass: "messageHeading" }, [
                        _vm._v(
                          _vm._s(message.sender.givenName) +
                            " " +
                            _vm._s(message.sender.familyName) +
                            ", " +
                            _vm._s(
                              _vm.formattedDateTimeString(
                                message.dateTime.toDate(),
                                _vm.selectedEvent.location,
                                _vm.appUser.timeZoneIdentifier
                              )
                            )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class:
                            _vm.appUser &&
                            _vm.appUser.uid == message.sender.userId
                              ? "messageBody_sender"
                              : "messageBody_notSender"
                        },
                        [_vm._v(_vm._s(message.body))]
                      )
                    ])
                  }),
                  0
                )
              : _c("div", [
                  _c("p", { staticClass: "emptyList" }, [_vm._v("No messages")])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bottomBar" }, [
        _c("div", { staticClass: "grow-wrap" }, [
          _c("textarea", {
            ref: "inputField",
            attrs: {
              name: "text",
              id: "text",
              onInput: "this.parentNode.dataset.replicatedValue = this.value"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.sendMessage(_vm.selectedEvent, _vm.appUser)
              }
            }
          },
          [_vm._v("Send")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7218dcc5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7218dcc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageList.vue
// module id = null
// module chunks = 